import type { Coordinates } from './coordinates';

export function haversineDistance(mark1: Coordinates, mark2: Coordinates) {
    const R = 6371.071; // Radius of the Earth in kilometers

    const rlat1 = mark1.latitude * (Math.PI / 180); // Convert degrees to radians
    const rlat2 = mark2.latitude * (Math.PI / 180); // Convert degrees to radians
    const difflat = rlat2 - rlat1; // Radian difference (latitudes)
    const difflon = (mark2.longitude - mark1.longitude) * (Math.PI / 180); // Radian difference (longitudes)

    const distance =
        2 *
        R *
        Math.asin(
            Math.sqrt(
                Math.sin(difflat / 2) * Math.sin(difflat / 2) +
                    Math.cos(rlat1) *
                        Math.cos(rlat2) *
                        Math.sin(difflon / 2) *
                        Math.sin(difflon / 2),
            ),
        );
    return distance;
}
